import { createStore } from "vuex";
import userModule from "./modules/user.vuex";
import settingsModule from "./modules/settings.vuex";
import servicesModule from "./modules/services.vuex";
import optionsModule from "./modules/options.vuex";

const storeConfig = {
  modules: {
   user: userModule,
   settings: settingsModule,
   services: servicesModule,
   options: optionsModule,
  },
};

export default createStore(storeConfig);
